import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '..';
import { AccountType } from '../../api/userApi';

export const selectSelf = (state: RootState) => state.account;

export const selectIsSubscribed = createSelector(
  selectSelf,
  ({ accountType }) => accountType === AccountType.Subscribed
);

export const selectDesiredCreditsAmount = createSelector(
  selectSelf,
  ({ desiredCreditsAmount }) => desiredCreditsAmount
);
